import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  payment = 'PricingPaymentWindows3',
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/windows3/',
    component: () => import('@/modules/windows/layout/LayoutPage.vue'),
    children: [
      {
        path: 'payment/',
        name: MODULE_ROUTE.payment,
        component: () =>
          import('@/modules/windows3/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
